import { COVER_FONT_SIZE_PT_RANGE } from 'photobooks/constants/albumConstants';

export const init = {
  customizations: {
    albumSize: null,
    coverColor: null,
    initialized: false,
    synced: true,
    isBlank: false,
    font: null,
    fontSize: COVER_FONT_SIZE_PT_RANGE.min,
    foil: null,
    coverText: '',
    hasDisplayBox: false,
    displayBoxText: '',
  },
  coverDesignTemplates: [],
};

const reducer = (state = init, action) => {
  switch (action.type) {
    case 'SET_COVER_CUSTOMIZATIONS': {
      return {
        ...state,
        customizations: { ...state.customizations, ...action.payload },
      };
    }
    case 'CLEAR_COVER_CUSTOMIZATIONS': {
      return {
        ...state,
        customizations: init.customizations,
      };
    }
    case 'SET_COVER_DESIGN_TEMPLATES': {
      return {
        ...state,
        coverDesignTemplates: action.payload.coverDesignTemplates,
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/photobooks/reducers/coverCustomization/reducer.js